import React, { useState } from "react";
import "../Styles/AddFamilyWealthForClient.css";
import { delete_family_wealth } from "../api/serverWrapper";

export default function AddFamilyWealthForClient({
  familyWealth,
  setFamilyWealth,
}) {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [wealthForm, setWealthForm] = useState({
    PropertyType: "",
    Description: "",
    EstimatedValue: "",
    OwnershipType: "",
    Location: "",
    Notes: "",
  });

  // Property Type options
  const propertyTypeOptions = [
    { id: 1, name: "Land" },
    { id: 2, name: "House" },
    { id: 3, name: "Business" },
    { id: 4, name: "Vehicle" },
    { id: 5, name: "Jewellery" },
    { id: 6, name: "Investment" },
    { id: 7, name: "Other" },
  ];

  // Ownership Type options
  const ownershipTypeOptions = [
    { id: 1, name: "Individual" },
    { id: 2, name: "Joint" },
    { id: 3, name: "Ancestral" },
    { id: 4, name: "Inherited" },
  ];

  const openAddModal = () => {
    setEditingIndex(null);
    setWealthForm({
      PropertyType: "",
      Description: "",
      EstimatedValue: "",
      OwnershipType: "",
      Location: "",
      Notes: "",
    });
    setModalVisible(true);
  };

  const openEditModal = (index) => {
    setEditingIndex(index);
    setWealthForm(familyWealth[index]);
    setModalVisible(true);
  };

  const handleWealthChange = (field, value) => {
    setWealthForm({ ...wealthForm, [field]: value });
  };

  const handleSaveWealth = () => {
    if (!wealthForm.PropertyType || !wealthForm.OwnershipType) {
      alert("Please select Property Type and Ownership Type.");
      return;
    }

    if (editingIndex !== null) {
      const updated = [...familyWealth];
      updated[editingIndex] = wealthForm;
      setFamilyWealth(updated);
    } else {
      setFamilyWealth([...familyWealth, wealthForm]);
    }

    setModalVisible(false);
    setEditingIndex(null);
  };

  const handleDelete = async (index, wealth) => {
    // If item is not yet saved in DB
    if (!wealth?.WealthId) {
      const updated = [...familyWealth];
      updated.splice(index, 1);
      setFamilyWealth(updated);
      return;
    }

    if (!window.confirm("Are you sure you want to delete this wealth item?")) {
      return;
    }

    try {
      const response = await delete_family_wealth(wealth.WealthId);

      if (response?.status === 200 || response?.success) {
        const updated = [...familyWealth];
        updated.splice(index, 1);
        setFamilyWealth(updated);
      } else {
        alert("Failed to delete wealth");
      }
    } catch (error) {
      console.error("Delete wealth error:", error);
      alert("Failed to delete wealth from server");
    }
  };
  return (
    <section className="background-section">
      <header className="background-section__header">
        <h2 className="background-section__title">Family Wealth</h2>
        <div className="background-section__divider" />
      </header>

      {/* Wealth List */}
      <div className="wealth-list">
        {familyWealth.length === 0 && (
          <p className="text-muted">No wealth added yet.</p>
        )}
        {familyWealth.map((wealth, index) => (
          <div key={index} className="wealth-item">
            <div className="wealth-info">
              <strong>
                {propertyTypeOptions.find(
                  (opt) => opt.id === wealth.PropertyType,
                )?.name || "Unknown"}
              </strong>{" "}
              - {wealth.Description || "No Description"} (
              {wealth.EstimatedValue ? `₹${wealth.EstimatedValue}` : "N/A"})
            </div>
            <div className="wealth-actions">
              <button
                className="btn-action edit"
                onClick={() => openEditModal(index)}
              >
                ✏️ Edit
              </button>
              <button
                className="btn-action delete"
                onClick={() => handleDelete(index, wealth)}
              >
                ❌ Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Add Wealth Button */}
      <div className="add-family-members" onClick={openAddModal}>
        <div className="add-rel-text">+ Add Wealth</div>
      </div>

      {/* Modal */}
      {/* Modal */}
      {modalVisible && (
        <div className="add-family-modal__overlay">
          <div className="add-family-modal__content">
            {/* <h3 className="add-family-modal__title">
        {editingIndex !== null ? "Edit Wealth" : "Add Wealth"}
      </h3> */}

            {/* Row 1: Property Type + Ownership Type */}
            <div className="modal-row">
              <div className="modal-field">
                <label className="add-family-modal__label">
                  Property Type:
                </label>
                <select
                  className="add-family-modal__select"
                  value={wealthForm.PropertyType}
                  onChange={(e) =>
                    handleWealthChange("PropertyType", parseInt(e.target.value))
                  }
                >
                  <option value="">Select Property Type</option>
                  {propertyTypeOptions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="modal-field">
                <label className="add-family-modal__label">
                  Ownership Type:
                </label>
                <select
                  className="add-family-modal__select"
                  value={wealthForm.OwnershipType}
                  onChange={(e) =>
                    handleWealthChange(
                      "OwnershipType",
                      parseInt(e.target.value),
                    )
                  }
                >
                  <option value="">Select Ownership Type</option>
                  {ownershipTypeOptions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 2: Description + Estimated Value */}
            <div className="modal-row">
              <div className="modal-field">
                <label className="add-family-modal__label">Description:</label>
                <input
                  className="add-family-modal__input"
                  value={wealthForm.Description}
                  onChange={(e) =>
                    handleWealthChange("Description", e.target.value)
                  }
                  placeholder="Enter description"
                />
              </div>

              <div className="modal-field">
                <label className="add-family-modal__label">
                  Estimated Value:
                </label>
                <input
                  className="add-family-modal__input"
                  type="text"
                  value={wealthForm.EstimatedValue}
                  onChange={(e) =>
                    handleWealthChange("EstimatedValue", e.target.value)
                  }
                  placeholder="Enter value "
                />
              </div>
            </div>

            {/* Row 3: Location (full width) */}
            <div className="modal-row">
              <div className="modal-field full-width">
                <label className="add-family-modal__label">Location:</label>
                <input
                  className="add-family-modal__input"
                  value={wealthForm.Location}
                  onChange={(e) =>
                    handleWealthChange("Location", e.target.value)
                  }
                  placeholder="Enter location"
                />
              </div>
            </div>

            {/* Row 4: Notes (full width) */}
            <div className="modal-row">
              <div className="modal-field full-width">
                <label className="add-family-modal__label">Notes:</label>
                <textarea
                  className="add-family-modal__input pt-3"
                  rows="2"
                  value={wealthForm.Notes}
                  onChange={(e) => handleWealthChange("Notes", e.target.value)}
                  placeholder="Additional notes"
                />
              </div>
            </div>

            <div className="add-family-modal__button-row">
              <button
                className="add-family-modal__button"
                onClick={handleSaveWealth}
              >
                {editingIndex !== null ? "Update" : "Add"}
              </button>
              <button
                className="add-family-modal__button add-family-modal__button--cancel"
                onClick={() => setModalVisible(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
